import {isNotNilOrEmpty} from 'shared/web';

import {AuctionEnumLookup} from '../hooks/useAuctionEnumLookup';
import {resolveAuctionEnumLabel} from './resolveAuctionEnumLabel';

/**
 * Builds a deduplicated vehicle title from make, model and adTitle.
 *
 * Model labels returned by the enum API often include the make prefix
 * (e.g. make = "BMW", model = "BMW X7"). Naively concatenating all three
 * parts produces "BMW BMW X7 SUV M SPORTPAKET PRO". This function strips
 * the leading make from the model label when it is duplicated, yielding
 * "BMW X7 SUV M SPORTPAKET PRO".
 */
export function buildAuctionVehicleTitle(
  make: string | null | undefined,
  model: string | null | undefined,
  adTitle: string | null | undefined,
  enumLookup: AuctionEnumLookup
): string {
  const resolvedMake = resolveAuctionEnumLabel(make, enumLookup);
  const resolvedModel = resolveAuctionEnumLabel(model, enumLookup);

  const modelWithoutMake =
    isNotNilOrEmpty(resolvedMake) &&
    isNotNilOrEmpty(resolvedModel) &&
    resolvedModel.startsWith(resolvedMake)
      ? resolvedModel.slice(resolvedMake.length).trimStart()
      : resolvedModel;

  return [resolvedMake, modelWithoutMake, adTitle].filter(isNotNilOrEmpty).join(' ');
}
